import React from 'react';
import { useAuth } from '../../context/AuthContext';

/**
 * Affiche les enfants uniquement si l'utilisateur a la/les permission(s) requise(s).
 *
 * @example
 * <Can permission="users:suspend"><button>Suspendre</button></Can>
 * <Can anyOf={['users:role', 'users:write']}>...</Can>
 * <Can allOf={['users:read', 'users:write']}>...</Can>
 */
const Can = ({ permission, anyOf, allOf, children, fallback = null }) => {
  const { hasPermission, hasAnyPermission, user } = useAuth();

  let allowed = false;

  if (permission) {
    allowed = hasPermission(permission);
  } else if (Array.isArray(anyOf) && anyOf.length > 0) {
    allowed = hasAnyPermission(...anyOf);
  } else if (Array.isArray(allOf) && allOf.length > 0) {
    allowed = allOf.every((p) => hasPermission(p));
  } else {
    allowed = Boolean(user);
  }

  if (!allowed) return fallback;
  return <>{children}</>;
};

export default Can;
